import { Table } from '@flos/react-ui';
import { type CoverageDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { useHippoText } from '../../hooks/useHippoText';
import CoverageTableRow from '../CoverageTable/CoverageTableRow';
import useWindowSize from '../../hooks/useWindowSize';

const ExcludedCoverages = ({
    shouldRenderTitle = false,
    showCoverableDetailsUI,
    excludedCoverages,
    flavourName,
    coverableId,
    includedCoverages = []
}: {
    shouldRenderTitle?: boolean;
    showCoverableDetailsUI: boolean;
    excludedCoverages: CoverageDTO[] | undefined;
    flavourName: string;
    coverableId: string;
    includedCoverages: CoverageDTO[] | undefined;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const { isMobileDevice } = useWindowSize();

    const getActionForExcludedCoverages = (coverage: CoverageDTO): React.JSX.Element => {
        //  If line is workers compensation (WOC) or Agriculture content (CTP) the button should not be visible
        const lineIdentifier = coverage.type?.substring(0, 3);
        if (lineIdentifier === 'WOC' || lineIdentifier === 'CTP') return <></>;

        if (coverage.declinedByTopdanmark_Top)
            return <span>{getHippoText('DSS-SHOPPING-BASKET-MISSING-COVERAGES-UNAVAILABLE')}</span>;

        return <></>;
    };

    if (excludedCoverages?.length === 0) {
        return <></>;
    }
    return (
        <>
            <div className="excluded-coverages-container">
                {shouldRenderTitle && (
                    <div className="u-flex-box u-flex-box--space-between">
                        <h4>{getHippoText('DSS-SHOPPING-BASKET-MISSING-COVERAGES-TITLE')}</h4>
                    </div>
                )}
                <Table mobileDirection="vertical" wrapped={isMobileDevice}>
                    <Table.Body>
                        {excludedCoverages?.map((coverage) => {
                            return (
                                <CoverageTableRow
                                    coverage={coverage}
                                    iconProps={
                                        !showCoverableDetailsUI
                                            ? {
                                                  shape: 'circle-close',
                                                  className: 'has-fill is-grey'
                                              }
                                            : undefined
                                    }
                                    showValueCell={!showCoverableDetailsUI}
                                    key={coverage.name}
                                    showPrice={true}
                                    showActionButton={getActionForExcludedCoverages(coverage)}
                                />
                            );
                        })}
                    </Table.Body>
                </Table>
            </div>
        </>
    );
};

export default ExcludedCoverages;
